module.exports = __webpack_public_path__ + "4dbe935b650e7e705b657da9995ceb1f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Glyphter.svg
// module id = KIBH
// module chunks = 0